export enum UserManagerOpCode {
    DELETE_GROUP = 'delete_group',
    ADD_USER = 'add_user',
    REMOVE_USER = 'remove_user',
    ADD_GROUP = 'add_group'
}